import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "vue-nprogress";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/Index.vue"),
    meta: {
      auth: true,
      title: "Mohamed Sabry: Personal Portfolio",
      showProgressBar: true
    },
    props: { mode: "light" }
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import("@/views/Projects.vue"),
    meta: {
      auth: true,
      title: "Mohamed Sabry: Projects",
      showProgressBar: true
    }
  },
  {
    path: "/flags",
    name: "Flags",
    component: () => import("@/views/Flags.vue"),
    meta: {
      auth: true,
      title: "Mohamed Sabry: Flags for fun",
      showProgressBar: true
    }
  },
  {
    path: "/connect",
    name: "Connect",
    component: () => import("@/views/Connect.vue"),
    meta: {
      auth: true,
      title: "Connect with me",
      showProgressBar: true
    }
  },
  {
    path: "*",
    name: "Not Found",
    component: () => import("@/views/NotFound.vue"),
    meta: {
      auth: true,
      title: "Not Found 404",
      showProgressBar: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  NProgress.start();
  next();
});

router.afterEach(() => {
  // NProgress.done();
});

export default router;
